import ApprovePaymentPlanError from './ApprovePaymentPlanError';
class InvalidPaymentPlanStatus extends ApprovePaymentPlanError {
    constructor(options) {
        super('Payment plan status is invalid', options);
    }
}
export default InvalidPaymentPlanStatus;
